import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetPortfolioAgingResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "tiers": [
                    {"code": "not_due", "label": "Deuda no vencida", "total": {"amount": 45000.00, "currency": "ARS"}},
                    {"code": "1_to_7", "label": "0 a 7 días", "total": {"amount": 12000.00, "currency": "ARS"}},
                    {"code": "8_to_15", "label": "+7 a 15", "total": {"amount": 8000.00, "currency": "ARS"}},
                    {"code": "16_to_21", "label": "+15 a 21", "total": {"amount": 3000.00, "currency": "ARS"}},
                    {"code": "22_to_30", "label": "+21 a 30", "total": {"amount": 2000.00, "currency": "ARS"}},
                    {"code": "31_to_90", "label": "+30 a 90", "total": {"amount": 6000.00, "currency": "ARS"}},
                    {"code": "over_90", "label": "+90", "total": {"amount": 9000.00, "currency": "ARS"}},
                    {"code": "prejudicial_management", "label": "Pre Gestión Judicial", "total": {"amount": 4000.00, "currency": "ARS"}},
                    {"code": "judicial_management", "label": "Gestión Judicial", "total": {"amount": 5000.00, "currency": "ARS"}},
                ],
                "total": {"amount": 94000.00, "currency": "ARS"},
            },
            errors: []
        }
    }

    tiers() {
        return this.content().tiers.map(tier => ({
            code: tier.code,
            label: tier.label,
            total: tier.total,
        }));
    }

    total() {
        return this.content().total;
    }
}
